import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "asnip" }
const _hoisted_2 = {
  class: "sui-card sui-card--flush",
  "data-tour": "admin-content-snippets-list"
}
const _hoisted_3 = {
  class: "sui-toolbar",
  "data-tour": "admin-content-snippets-toolbar"
}
const _hoisted_4 = { class: "asnip__filter" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "asnip__error"
}
const _hoisted_7 = {
  key: 1,
  class: "asnip__grid"
}
const _hoisted_8 = { class: "sui-badge sui-badge--gray" }
const _hoisted_9 = { class: "asnip__preview" }
const _hoisted_10 = {
  key: 0,
  class: "asnip__meta"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 2,
  class: "asnip__empty"
}
const _hoisted_13 = {
  key: 0,
  class: "asnip__modal",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_14 = {
  class: "asnip__modal-panel",
  "data-tour": "admin-content-snippets-editor"
}
const _hoisted_15 = { class: "asnip__form" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "is-full" }
const _hoisted_18 = { class: "is-full" }
const _hoisted_19 = {
  key: 0,
  class: "asnip__field-hint"
}
const _hoisted_20 = {
  class: "asnip__live",
  "data-tour": "admin-content-snippets-preview"
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 1,
  class: "asnip__text"
}
const _hoisted_23 = ["disabled"]

import { onMounted, reactive, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import {
  fetchAdminSnippets,
  saveAdminSnippet,
  type ContentSnippet,
} from '@/api/admin'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminContentSnippetsPage',
  setup(__props) {

const snippets = ref<ContentSnippet[]>([])
const group = ref('')
const loading = ref(false)
const saving = ref(false)
const errorMessage = ref('')
const modalOpen = ref(false)

const form = reactive<ContentSnippet>({
  key: '',
  title: '',
  group: 'mall',
  format: 'text',
  body: '',
})

function previewText(body: string) {
  return body.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 120)
}

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    snippets.value = await fetchAdminSnippets(group.value)
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '멘트를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

function openEdit(row: ContentSnippet) {
  form.key = row.key
  form.title = row.title
  form.group = row.group
  form.format = row.format
  form.body = row.body
  modalOpen.value = true
}

function closeModal() {
  modalOpen.value = false
}

async function onSave() {
  if (!form.key || !form.title) {
    window.alert('제목을 입력해 주세요.')
    return
  }
  saving.value = true
  try {
    await saveAdminSnippet({ ...form })
    modalOpen.value = false
    await load()
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '저장에 실패했습니다.')
  } finally {
    saving.value = false
  }
}

onMounted(load)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("p", { class: "asnip__lead" }, [
      _createTextVNode(" 몰·포털·판매 화면에 노출되는 안내 문구를 키 단위로 수정합니다. 저장 즉시 공개 API에 반영됩니다. 당일 출고 안내는 "),
      _createElementVNode("code", null, "mall.product.same_day_cutoff"),
      _createTextVNode(" 이며, 본문을 비우면 상품상세·스토어에서 숨겨집니다. ")
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("strong", null, "멘트 목록", -1)),
        _createElementVNode("label", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "그룹", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((group).value = $event)),
            onChange: load
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("option", { value: "" }, "전체", -1),
            _createElementVNode("option", { value: "mall" }, "몰", -1),
            _createElementVNode("option", { value: "portal" }, "포털", -1),
            _createElementVNode("option", { value: "seller" }, "판매", -1)
          ]))], 544), [
            [_vModelSelect, group.value]
          ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: load
        }, "새로고침", 8, _hoisted_5)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true),
      (snippets.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(snippets.value, (row) => {
              return (_openBlock(), _createElementBlock("article", {
                key: row.key,
                class: "asnip__card",
                "data-tour": "admin-content-snippets-item"
              }, [
                _createElementVNode("header", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("code", null, _toDisplayString(row.key), 1),
                    _createElementVNode("h3", null, _toDisplayString(row.title), 1)
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.group) + " · " + _toDisplayString(row.format), 1)
                ]),
                _createElementVNode("p", _hoisted_9, _toDisplayString(previewText(row.body)), 1),
                _createElementVNode("footer", null, [
                  (row.updatedAt)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "수정 " + _toDisplayString(row.updatedAt), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "sui-btn sui-btn--sm",
                    onClick: ($event: any) => (openEdit(row))
                  }, "편집", 8, _hoisted_11)
                ])
              ]))
            }), 128))
          ]))
        : (!loading.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "등록된 멘트가 없습니다."))
          : _createCommentVNode("", true)
    ]),
    (modalOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "asnip__modal-backdrop",
            onClick: closeModal
          }),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("header", null, [
              _cache[9] || (_cache[9] = _createElementVNode("h2", null, "멘트 편집", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--sm",
                onClick: closeModal
              }, "닫기")
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", null, [
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "키", -1)),
                _createElementVNode("input", {
                  value: form.key,
                  readonly: ""
                }, null, 8, _hoisted_16)
              ]),
              _createElementVNode("label", null, [
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "그룹", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.group) = $event))
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("option", { value: "mall" }, "mall", -1),
                  _createElementVNode("option", { value: "portal" }, "portal", -1),
                  _createElementVNode("option", { value: "seller" }, "seller", -1)
                ]))], 512), [
                  [_vModelSelect, form.group]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[14] || (_cache[14] = _createElementVNode("span", null, "형식", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.format) = $event))
                }, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("option", { value: "text" }, "text", -1),
                  _createElementVNode("option", { value: "html" }, "html", -1)
                ]))], 512), [
                  [_vModelSelect, form.format]
                ])
              ]),
              _createElementVNode("label", _hoisted_17, [
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "제목", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.title) = $event)),
                  maxlength: "120"
                }, null, 512), [
                  [
                    _vModelText,
                    form.title,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("label", _hoisted_18, [
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "본문", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.body) = $event)),
                  rows: "12"
                }, null, 512), [
                  [_vModelText, form.body]
                ])
              ]),
              (form.key === 'mall.product.same_day_cutoff')
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("code", null, "{cutoff}", -1),
                    _createTextVNode(" 자리에 판매업체 마감 시각(예: 14시)이 들어갑니다. 본문을 비우면 상품상세·스토어에서 당일 출고 안내가 숨겨집니다. ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[18] || (_cache[18] = _createElementVNode("h3", null, "미리보기", -1)),
              (form.format === 'html')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "asnip__html",
                    innerHTML: form.body
                  }, null, 8, _hoisted_21))
                : (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(form.body), 1))
            ]),
            _createElementVNode("footer", null, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeModal
              }, "취소"),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: saving.value,
                onClick: onSave
              }, _toDisplayString(saving.value ? '저장 중…' : '저장'), 9, _hoisted_23)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})